<div class="main-container">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <span>ZingHR Employee</span>
            </div>
        </div>

        <div class="card-body p-0">
            <div class="filter-section">
                <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label for="Monthyear" class="form-label">Month Year</label><br />
                            <ngb-datepicker #dp [(ngModel)]="Filter.MonthYearObj" class="month-year"
                                (navigate)="Filter.MonthYearObj= $event.next;onNavigate($event);clear()"
                                name="month-year"></ngb-datepicker>
                        </div>
                        <div class="col-md-3">
                            <label for="Status" class="form-label">Status</label>
                            <select class="form-select" aria-label="filterType" placeholder="filterType" title="Status"
                                name="Status" [(ngModel)]="Filter.Status" #Status="ngModel" (change)="clear()" required>
                                <option value='ALL'>All</option>
                                <option value='SUCCESS'>Success</option>
                                <option value='FAILURE'>Failure</option>
                            </select>
                        </div>
                        <div class="col"></div>
                        <div class="col-md-auto align-self-end pb-2 gap-2">
                            <button class="btn btn-primary mx-2">
                                <i class="bi bi-funnel me-1"></i> Apply
                            </button>
                            <button type="button" class="btn btn-outline-primary" *ngIf="this.common.PageRight.IsPrint"
                                [disabled]="this.EmployeeData.length == 0" (click)="ExportExcel()">
                                <i class="bi bi-download me-1"></i> Export
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="table-container mt-2">
                <table class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th>Details</th>
                            <th>Email</th>
                            <th>Mobile No</th>
                            <th>UANNo</th>
                            <th>OperationType</th>
                            <th>RequestDate</th>
                            <th>Data Synced On</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let element of EmployeeData; let i = index">
                            <tr [class.expanded-row]="element.expanded">
                                <td>
                                    <div class="row" style="align-items: center;"
                                        style="align-items: center;width: 300px;">
                                        <div class="col-12">
                                            <span class="text-label">Temp Code{{element['EmpTempCode']}} </span>
                                            <br />
                                            <span>[ZingHR Code: {{element['ZingHrCode']}}]</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {{element['EmailId']}}
                                </td>
                                <td>
                                    {{element['MobileNo']}}
                                </td>
                                <td>
                                    {{element['UANNo']}}
                                </td>
                                <td>
                                    {{element['OperationType']}}
                                </td>
                                <td>
                                    {{element['RequestDate']}}
                                </td>
                                <td>
                                    {{element['DataSyncedOn']}}
                                </td>
                                <td>
                                    <span class="badge"
                                        [ngClass]="{'success': common.ToLowerCase(element.Status) == 'success', 'danger':common.ToLowerCase(element.Status) != 'success'}">{{element.Status}}</span>
                                </td>
                            </tr>
                            <tr class="details-row" *ngIf="element.expanded">
                                <td colspan="7" class="details-cell p-2">
                                    <div class="details-grid">
                                        <div class="detail-item">
                                            <span class="detail-label">Error Message</span>
                                            <span class="detail-value">
                                                {{element.ErrorMessage}}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>